import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';

/**
 * POST /sso/okta/token {code, verifier} => {token, refresh_token, refresh_token_expiration}, comme /login :
 * échange le code à usage unique du retour d'Okta (cf. src/security/sso.ts)
 */
export default class OktaTokenModel extends AbstractApiModel {
  protected _path = '/sso/okta/token';

  @doc.string declare token: string;
  @doc.string declare refresh_token: string;
  /** Timestamp (s) d'expiration du refresh token */
  @doc.number declare refresh_token_expiration: number;
}
